<template>
    <toggle-button
      :value="toggle"
      :labels="{checked: 'Admin Emails', unchecked: 'No Admin Emails'}"
      :width="120"
      class="mr-2"
      @change="adminEmails($event)"
    />
</template>

<script>
import axios from 'axios'
import { ToggleButton } from 'vue-js-toggle-button'

Vue.component('ToggleButton', ToggleButton)

  export default {
      components: {
        ToggleButton
      },
        props: {
            route:'',
            routeparam:'',
            toggle: '',
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
          }
        },

        methods: {

          adminEmails: function (event) {
            let value = event.value ? 1:0;
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              axios.put(this.route,
                { [this.routeparam]: value }
              )
              .then(function (response) {
                  console.log(response);
                })
            };
          }

        },
      }
</script>